import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { Head } from 'modules/shared/components/Head';
import AdminLayout from '../../../../pages/apps/Admin/Admin.layout';
import { Box } from '@chakra-ui/react';
import Retently from 'utils/retently/Retently';

const Admin = (props) => {
  useEffect(() => {
    if (typeof window !== 'undefined' && window.zE && window.zE.hide) {
      window.zE.hide();
    }
  }, []);

  return (
    <AdminLayout allowedScopes={props.allowedRoles}>
      <Head title={props.title} />
      <Box backgroundColor="background-subtle" padding={6} minHeight="100vh">
        {props.children}
        <Retently />
      </Box>
    </AdminLayout>
  );
};

Admin.propTypes = {
  allowed: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  allowedRoles: PropTypes.array,
  children: PropTypes.any,
  darkBg: PropTypes.any,
  full: PropTypes.bool,
  title: PropTypes.string,
};

Admin.defaultProps = {
  allowed: true,
  allowedRoles: null,
  full: false,
  title: '',
};

export { Admin };
export default Admin;
